const menuToggle = document.querySelector('.menu-toggle');
const siteNav = document.querySelector('#site-nav');

menuToggle?.addEventListener('click', () => {
  const isOpen = siteNav.classList.toggle('is-open');
  menuToggle.setAttribute('aria-expanded', String(isOpen));
});

document.querySelectorAll('.site-nav a').forEach((link) => link.addEventListener('click', () => {
  siteNav?.classList.remove('is-open');
  menuToggle?.setAttribute('aria-expanded', 'false');
}));

const countdown = document.querySelector('[data-countdown-end]');
const pad = (value) => String(Math.max(0, value)).padStart(2, '0');
const updateCountdown = () => {
  if (!countdown) return;
  const end = new Date(countdown.dataset.countdownEnd).getTime();
  const remaining = end - Date.now();
  if (remaining <= 0) {
    countdown.innerHTML = '<span class="countdown-ended">Campanha em atualização</span>';
    return;
  }
  const totalSeconds = Math.floor(remaining / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  countdown.querySelector('[data-days]').textContent = pad(days);
  countdown.querySelector('[data-hours]').textContent = pad(hours);
  countdown.querySelector('[data-minutes]').textContent = pad(minutes);
  countdown.querySelector('[data-seconds]').textContent = pad(seconds);
};
updateCountdown();
setInterval(updateCountdown, 1000);

document.querySelector('[data-year]')?.replaceChildren(String(new Date().getFullYear()));

const revealItems = document.querySelectorAll('.product-card, .category-row, .trust-point');
if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  revealItems.forEach((item) => { item.style.opacity = '0'; item.style.transform = 'translateY(12px)'; item.style.transition = 'opacity .5s ease, transform .5s ease'; });
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.style.opacity = '1';
      entry.target.style.transform = 'translateY(0)';
      obs.unobserve(entry.target);
    });
  }, { threshold: .12 });
  revealItems.forEach((item) => observer.observe(item));
}
